import React, { useState } from 'react';
import { transformLabels } from '../../../../utils/misc';
import tick from '../../../../static/img/tick.svg';
import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import { Colors } from '~/src/scss/common/style';

interface CheckboxInputProps {
  id?: string;
  name: string;
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  label?: string;
  disabled?: boolean;
  cols?: number;
}

export default function CheckboxInputComponent({
  id = '',
  name,
  checked,
  onChange,
  label = null,
  disabled = false,
  cols = 3,
}: CheckboxInputProps): JSX.Element {

  return (
    <CheckboxContainer className={`col-sm-${cols} form-check`}>
      <StyledCheckbox checked={checked} disabled={disabled}>
        <HiddenCheckbox
          {...(id ? { id } : {})}
          type="checkbox"
          name={name}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        <StyledImg src={tick} checked={checked} />
      </StyledCheckbox>
      <LabelStyle className="form-check-label ak-form-labels" {...(id ? { htmlFor: id } : {})}>
        {label || transformLabels(label)}
      </LabelStyle>
    </CheckboxContainer>
  );
}

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${Colors.darkBrown};
  text-align: left;
  width: 100%;
`;

const StyledImg = styled(ReactSVG)`
  height: 14px !important;
  display: flex;
  div {
    display: flex;
  }
  svg {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
  transition: 0.3s ease-in-out;
  transform: ${(props) => (props.rotateIcon ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const StyledCheckbox = styled.div`
  position: relative;
  width: 20px;
  height: 20px; 
  background-color: ${(props) => (props.checked ? `${Colors.lightBrown}` : '#fff')}; 
  border: 2px solid
    ${(props) => (props.checked ? `${Colors.darkBrown}` : '#cccccc')}; 
  border-radius: 3px;
  box-shadow: ${(props) =>
    props.checked ? '0 0 5px rgba(139, 69, 19, 0.5)' : 'none'}; 
  transition: all 150ms ease-in-out;
  margin-right: 5px;
  &:hover {
    border: 2px solid ${Colors.darkBrown}; 
    box-shadow: 0 0 5px rgba(139, 69, 19, 0.3); 
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HiddenCheckbox = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  z-index: 3;
  cursor: pointer;
`;
